import type { BillingCurrency } from '@contracts/payment/Currency';
import { TransactionCurrency } from '@contracts/payment/Currency';
import { BillingCurrencyField } from '@src/clients/financialSettings/fields/CurrencyFields';
import { FormDropdown } from '@src/common/components/FormDropdown';
import Config from '@src/config/Config';
import type { Control, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type CurrencyFieldValue = FieldValues & {
  [BillingCurrencyField.fieldName]?: BillingCurrency;
};
interface Props<T extends CurrencyFieldValue> {
  control: Control<T>;
  disabled?: boolean;
}

export const BillingCurrencyDropdown = <T extends CurrencyFieldValue>({
  control,
  disabled = false,
}: Props<T>) => {
  const { t } = useTranslation();
  const canadaOptions = [
    { label: t('currency.cad'), value: TransactionCurrency.CAD },
    { label: t('currency.usd'), value: TransactionCurrency.USD },
    { label: t('currency.all'), value: 'ALL' },
  ];
  const usOptions = [
    { label: t('currency.usd'), value: TransactionCurrency.USD },
  ];
  return (
    <FormDropdown
      fieldName={BillingCurrencyField.fieldName}
      control={control as Control<CurrencyFieldValue>}
      disabled={disabled}
      label={t('fields.currency')}
      options={Config.VITE_BRAND === 'Nova' ? canadaOptions : usOptions}
    />
  );
};
